import { render, staticRenderFns } from "./NewRegistrationSummary.vue?vue&type=template&id=7686df24&scoped=true"
import script from "./NewRegistrationSummary.vue?vue&type=script&lang=js"
export * from "./NewRegistrationSummary.vue?vue&type=script&lang=js"
import style0 from "./NewRegistrationSummary.vue?vue&type=style&index=0&id=7686df24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7686df24",
  null
  
)

export default component.exports